export default {
  notCausedByCountyError: null,
  paidInFull: null,
  doesNotExceed2500: null,
  penaltyDueToFailure: null,
  noPenaltyPriorThreeYears: null,
  owner: {
    fullName: '',
    phone: '',
    email: '',
    mailAddr: {
      street: '',
      city: '',
      state: '',
      zip: '',
    },
    serialNumber: '',
    additionalSerialNumbers: '',
    statement: '',
    agreedToTerms: false,
  },
};
